export default __webpack_public_path__ + "static/media/banner2.03d5b0f7.jpg";